module.exports = __webpack_public_path__ + "assets/togather.bb471ed7.svg";